import React from "react";
import './burger-button.styles.scss'
const BurgerButton = ({isOpen, className, ...otherProps})=>{
        return(
        <button
            aria-controls="responsive-navbar-nav"
            role="button"
            aria-label="Μενού Συσκευής Τηλεφώνου"
            className={`burger-btn${(className) ? ' '+className : ''}${(isOpen) ? ' is-open' : ''}`}
            {...otherProps}
        >
            <span aria-hidden={true} className="line"></span>
            <span aria-hidden={true} className="line"></span>
            <span aria-hidden={true} className="line"></span>
        </button>
    )
}
export default BurgerButton;
